import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fatura',
  templateUrl: './fatura.component.html',
  styleUrls: ['./fatura.component.scss']
})
export class FaturaComponent implements OnInit {

  constructor(
  ) { }

  ngOnInit(): void {

  }

}
